var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkle = function SvgSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7B7D",
    d: "m8 1 1.382 3.618L13 6 9.382 7.382 8 11 6.618 7.382 3 6l3.618-1.382z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7987FF",
    d: "m3.5 10.5.809 2.19 2.191.81-2.191.809L3.5 16.5l-.809-2.191L.5 13.5l2.191-.81z"
  })));
};
export default SvgSparkle;